module.exports = __webpack_public_path__ + "static/media/face_bg@3x.4a9d4f0a.webp";